import { environment } from './../../environments/environment';
import { AuthService } from './../Services/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private secureRoutes = [`${environment.apiUrl}/api`];

  constructor(
    private authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.secureRoutes.find((x) => request.url.startsWith(x))) {
      return next.handle(request);
    }

    this.authService.token().subscribe((token) => {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    });
    return next.handle(request);
  }
}
